export default "__VITE_ASSET__762084e6__"